import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { blogPosts, blogCategories } from '../data/blogData';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiClock, FiChevronLeft, FiChevronRight } = FiIcons;

const BlogList = () => {
  const [selectedCategory, setSelectedCategory] = useState("All Posts");
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 12;

  const filteredPosts = blogPosts.filter(post => 
    selectedCategory === "All Posts" || post.category === selectedCategory
  );

  // Pagination Logic
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = filteredPosts.slice(indexOfFirstPost, indexOfLastPost);
  const totalPages = Math.ceil(filteredPosts.length / postsPerPage);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="pt-32 pb-20 px-4 max-w-7xl mx-auto">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-white mb-4">Waconzy <span className="text-green-400">News</span></h1>
        <p className="text-gray-400">Latest updates, press releases, and viral trends.</p>
      </div>

      <div className="flex flex-wrap justify-center gap-3 mb-12">
        {blogCategories.map(category => (
          <button 
            key={category} 
            onClick={() => { setSelectedCategory(category); setCurrentPage(1); }}
            className={`px-4 py-2 rounded-lg font-medium transition-all ${selectedCategory === category ? 'bg-green-600 text-white' : 'bg-slate-800 text-slate-300'}`}
          >
            {category}
          </button>
        ))}
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
        {currentPosts.map(post => (
          <Link 
            key={post.id} 
            to={`/blog/${post.slug}`} 
            className="bg-slate-800 rounded-xl p-6 border border-slate-700 hover:border-green-500 transition-all group flex flex-col h-full"
          >
            <div className="text-green-400 text-sm mb-2 font-bold uppercase">{post.category}</div>
            <h2 className="text-xl font-bold text-white mb-3 group-hover:text-green-300 line-clamp-2">{post.title}</h2>
            <p className="text-slate-400 text-sm mb-4 line-clamp-3 flex-grow">{post.excerpt}</p>
            <div className="flex items-center justify-between text-slate-500 text-sm mt-auto pt-4 border-t border-slate-700">
              <div className="flex items-center gap-2"><SafeIcon icon={FiClock} /> {post.readTime}</div>
              <div>{post.date}</div>
            </div>
          </Link>
        ))}
      </div>

      {/* Pagination Controls */}
      <div className="flex justify-center gap-2">
        <button 
          onClick={() => paginate(Math.max(1, currentPage - 1))}
          disabled={currentPage === 1}
          className="p-3 rounded-lg bg-slate-800 text-white disabled:opacity-50 hover:bg-green-600 transition-colors"
        >
          <SafeIcon icon={FiChevronLeft} />
        </button>
        <span className="flex items-center px-4 font-bold text-white">
          Page {currentPage} of {totalPages}
        </span>
        <button 
          onClick={() => paginate(Math.min(totalPages, currentPage + 1))}
          disabled={currentPage === totalPages}
          className="p-3 rounded-lg bg-slate-800 text-white disabled:opacity-50 hover:bg-green-600 transition-colors"
        >
          <SafeIcon icon={FiChevronRight} />
        </button>
      </div>
    </div>
  );
};

export default BlogList;